// extracted by css-extract-rspack-plugin
export default {"HeaderTitle":"SavedQuestionHeaderButton-module__HeaderTitle___hm6LV"};